import { Bill } from '@mews-commander/data-access';
import { LocalizedMinorHighlight } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { OriginalBillInfo } from './OriginalBillInfo';
import { NewBillInfo } from './NewBillInfo';

interface DialogContentProps {
    fromBillTextKey?: Mews.TextKey;
    toBillTextKey: Mews.TextKey;
    fromBills: Bill[];
    toBill: Bill;
    oldBillName?: string;
    newBillName?: string;
}

export const DialogContent = ({
    fromBillTextKey,
    toBillTextKey,
    fromBills,
    toBill,
    oldBillName,
}: DialogContentProps) => (
    <Stack vertical spacing="300">
        <Stack vertical spacing="100">
            {fromBillTextKey ? <LocalizedMinorHighlight textKey={fromBillTextKey} /> : null}
            <OriginalBillInfo bills={fromBills} billName={oldBillName} />
        </Stack>
        <Stack vertical spacing="100">
            <LocalizedMinorHighlight textKey={toBillTextKey} />
            <NewBillInfo bill={toBill} />
        </Stack>
    </Stack>
);
